import axios from 'axios'
import { createPrefix } from 'utils/create-prefix'

export class TournamentService {
  // TEMP Storage of sport types
  SPORT_TYPES = {
    TENNIS_ATP: 'TENNIS_ATP',
    TENNIS_WTA: 'TENNIS_WTA',
  }

  constructor() {
    this.endpoints = createPrefix('/tournament', {
      tournamentsSearch: '/tournaments/search',
      tournamentsUpcomings: '/tournaments/upcomings',
      tournament: '/tournaments/',
    })
  }

  static create() {
    return new TournamentService()
  }

  async getTournamentsUpcomings(params = {}) {
    const servicePath = this.endpoints.tournamentsUpcomings()
    const requestParams = {
      page: 0,
      size: 20,
      upComingEventType: 'ALL',
      ...params,
    }

    const { data } = await axios.get(servicePath, {
      params: requestParams,
    })
    return data
  }

  async query(params) {
    params = {
      page: 0,
      size: 10,
      ...params,
    }

    const servicePath = this.endpoints.tournamentsSearch()

    const { data } = await axios.get(servicePath, {
      params: {
        sportType: params.sportType,
        tournamentName: params.search,
        size: params.size,
        page: params.page,
        startTimeEqOrGreater: params.startTimeEqOrGreater,
      },
    })

    return data
  }

  async getAllTournaments(params = {}) {
    const servicePath = this.endpoints.tournamentsSearch()
    const requestParams = {
      page: 0,
      size: 1000,
      ...params,
    }

    const { data } = await axios.get(servicePath, {
      params: requestParams,
    })
    return data
  }

  async get(id) {
    const servicePath = this.endpoints.tournament()
    const { data } = await axios.get(servicePath + id)
    return data
  }
}
